<template>
  <ul-page class="page-course-declaration">
    <template v-slot:left>
      <div class="page-header-left">
        <div class="page-header-title">{{ $t('pages_textbook_courseDeclaration_396') }}</div>
      </div>
    </template>
    <div class="page-content">
      <div class="declaration-tips">{{ $t('pages_textbook_courseDeclaration_397') }}</div>
      <div class="declaration-operation">
        <div class="course-label">{{ $t('pages_textbook_courseDeclaration_398') }}</div>
        <a class="help-trigger" href="http://help.ulearning.cn/?p=6078" target="_blank">{{ $t('pages_textbook_courseDeclaration_399') }}</a>
        <ul-button type="primary" @click="addCourse">{{ $t('pages_textbook_courseDeclaration_400') }}</ul-button>
      </div>
      <ul-table class="table-course" border :data="courseList">
        <ul-table-column
          prop="name"
          :label="$t('pages_textbook_courseDeclaration_384')">
        </ul-table-column>
        <ul-table-column
          prop="name"
          :label="$t('pages_textbook_courseDeclaration_385')"
          width="200px"
          >
          <template slot-scope="scope">
            <div class="declare-type">{{declareTypeMap[scope.row.declareType]}}</div>
          </template>
        </ul-table-column>
        <ul-table-column
          prop="termCount"
          :label="$t('pages_textbook_courseDeclaration_386')"
          width="100px">
        </ul-table-column>
           <ul-table-column
          prop="name"
          class-name="col-operate"
           width="240px"
          :label="$t('pages_textbook_courseDeclaration_387')">
          <template slot-scope="scope">
            <a href="javascript:;" @click="toTermManager(scope.row)">{{ $t('pages_textbook_courseDeclaration_401') }}</a>
            <a href="javascript:;" @click="modifyCourse(scope.row)">{{ $t('pages_textbook_courseDeclaration_402') }}</a>
            <a href="javascript:;" @click="deleteCourse(scope.row)">{{ $t('pages_textbook_courseDeclaration_403') }}</a>
          </template>
        </ul-table-column>
      </ul-table>
      <div class="pagination-wrapper" v-if="total > params.ps">
        <ul-pagination
          layout="prev, pager, next"
          :prevText="$t('pages_textbook_courseDeclaration_388')"
          :nextText="$t('pages_textbook_courseDeclaration_389')"
          :page-size="params.ps"
          @current-change="handleCurrentChange"
          :total="total">
        </ul-pagination>
      </div>
      
    </div>
    <ul-dialog
      ::title="$t('pages_textbook_courseDeclaration_390')"
      class="dialog-declaration"
      width="800px"
      @open="declarationDialogOpen"
      :visible.sync="declarationDialogVisiable">
      <ul-form ref="courseForm" :model="newCourse" label-width="100px" :rules="rules">
        <ul-form-item prop="name" :label="$t('pages_textbook_courseDeclaration_391')" class="form-item-name">
          <ul-input v-model="newCourse.name" :placeholder="$t('pages_textbook_courseDeclaration_392')"></ul-input>
        </ul-form-item>
        <ul-form-item prop="declareType" :label="$t('pages_textbook_courseDeclaration_393')" class="form-item-type">
          <ul-radio-group v-model.number="newCourse.declareType">
            <ul-radio :label="1">{{ $t('pages_textbook_courseDeclaration_404') }}</ul-radio>
            <ul-radio :label="2">{{ $t('pages_textbook_courseDeclaration_405') }}</ul-radio>
            <ul-radio :label="0">{{ $t('pages_textbook_courseDeclaration_406') }}</ul-radio>
          </ul-radio-group>
        </ul-form-item>
        <ul-form-item prop="courseId" :label="$t('pages_textbook_courseDeclaration_394')" class="form-item-origin">
          <div class="textbook-area">
            <div class="tips">{{ $t('pages_textbook_courseDeclaration_407') }}</div>
            <ul-input
              class="search-group"
              :placeholder="$t('pages_textbook_courseDeclaration_395')"
              clearable
              suffix-icon="icon-quanshipei-sousuo"
              search
              @search="originTextbookSearch"
              @keydown.native.enter="originTextbookSearch"
              v-model="originKeyword">
            </ul-input>
            <ul class="origin-textbooks-list">
              <li v-for="(item,index) in originTextbookList" :key="index">
                <ul-radio v-model="newCourse.courseId" :label="item.courseId" :disabled="item.allowfreedomreg != 1 || (!!item.declareCourseId && newCourse.originCourseId != item.courseId)">
                  <div class="radio-content">
                    <span class="title">{{item.name}}</span>
                    <span class="status" v-if="item.allowfreedomreg == 1">{{ $t('pages_textbook_courseDeclaration_408', { var0: item.courseId, var1: item.createTime | formatDate }) }}</span>
                    <span class="status" v-if="item.allowfreedomreg == 0">{{ $t('pages_textbook_courseDeclaration_409') }}</span>
                  </div>
                </ul-radio>
              </li>
            </ul>
          </div>
        </ul-form-item>
      </ul-form>
      <span slot="footer" class="dialog-footer">
        <ul-button type="primary" @click="submitAddCourse">{{ $t('pages_textbook_courseDeclaration_410') }}</ul-button>
        <ul-button plain @click="declarationDialogVisiable = false">{{ $t('pages_textbook_courseDeclaration_411') }}</ul-button>
      </span>
    </ul-dialog>
  </ul-page>
</template>

<script>
import { getDeclareCourseList,
         getDeclareOriginTextbookList, 
         saveDeclareCourse,
         deleteDeclareCourse
        } from '@/api/courseApi'
import formateDate from '@/mixins/formatDate.js'
export default {
  name: 'page-course-declaration',
  mixins: [formateDate],
  data () {
    return {
      courseList: [],
      declarationDialogVisiable: false,
      declareTypeMap: {
        '0': this.$t('pages_textbook_courseDeclaration_412'),
        '1': this.$t('pages_textbook_courseDeclaration_413'),
        '2': this.$t('pages_textbook_courseDeclaration_414')
      },
      newCourse: {},
      originKeyword: '',
      originTextbookList: [],
      total: 0,
      params: {
        ps: 10,
        pn: 1
      },
      rules: {
        name: [
          { required: true, message: this.$t('pages_textbook_courseDeclaration_415'), trigger: 'blur' },
          { max: 200, message:this.$t('pages_textbook_courseDeclaration_416'), trigger: 'blur' }
        ],
        declareType: [
          { required: true, message: this.$t('pages_textbook_courseDeclaration_417'), trigger: 'change' }
        ],
        courseId: [
          { required: true, message: this.$t('pages_textbook_courseDeclaration_418'), trigger: 'submit' }
        ]
      }
    }
  },
  created () {
    this.getDeclareCourseList()
  },
  methods: {
    getDeclareCourseList () {
      getDeclareCourseList(this.params)
        .then(({result}) => {
          this.courseList = result.list || []
          this.total = result.total
        })
    },
    handleCurrentChange (val) {
      this.params.pn = val
      this.getDeclareCourseList()
    },
    addCourse () {
      this.declarationDialogVisiable = true
      this.newCourse = {
        name: '',
        courseId: '',
        declareType: 1
      }
      this.getOriginTextbookList()
    },
    declarationDialogOpen () {
      this.$refs['courseForm'] && this.$refs['courseForm'].clearValidate()
      this.getOriginTextbookList()
    },
    originTextbookSearch () {
      this.getOriginTextbookList()
    },
    getOriginTextbookList  () {
      getDeclareOriginTextbookList({ courseName: this.originKeyword })
        .then(({result}) => {
          this.originTextbookList = result
        })
    },
    submitAddCourse () {
      this.$refs['courseForm'].validate(valid => {
        if (valid) {
          saveDeclareCourse(this.newCourse)
            .then(({result}) => {
              this.declarationDialogVisiable = false
              this.getDeclareCourseList()
            })
        }
      })
    },
    deleteCourse (item) {
      this.$confirm(this.$t('pages_textbook_courseDeclaration_419'), this.$t('pages_textbook_courseDeclaration_420'))
        .then(()=> {
          deleteDeclareCourse(item.id)
            .then(() => {
              this.getDeclareCourseList()
            })
        })
    },
    modifyCourse (item) {
      let course = JSON.parse(JSON.stringify(item))
      this.newCourse = course
      this.newCourse.originCourseId = course.courseId
      this.declarationDialogVisiable = true
    },
    toTermManager (item) {
      this.$router.push({
        name: 'termManager',
        query: {
          courseId: item.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-course-declaration{
  .page-content{
    padding: 20px;
    .declaration-operation{
      margin-top: 20px;
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      .course-label{
        flex: 1;
        font-weight: bold;
        font-size: 20px;
      }
      .help-trigger{
        color: $--color-link;
        margin-right: 10px;
      }
    }
    .table-course{
      .col-operate{
        a{
          margin-right: 10px;
          color: $--color-link;
        }
      }
    }
  }
  .pagination-wrapper{
    padding-top: 20px;
    text-align: center;
  }
  .dialog-declaration{
    .ul-form{

    }
    .form-item-name{
      .ul-input{
        width: 600px;
      }
    }
    .form-item-type{
      .ul-radio{
        width: 100%;
        line-height: 36px;
      }
    }
    .form-item-origin{
      .tips{
        font-size: 12px;
        color: $--color-text-secondary;
      }
      ::v-deep{
        &.is-error{
          .ul-input__inner{
            border-color: $--border-color-base;
          }
        }
      }
    }
    .textbook-area{
      .search-group {
        width: 300px;
      }
      .origin-textbooks-list{
        min-height: 240px;
        max-height: 360px;
        margin-top: 6px;
        overflow: auto;
      }
      .radio-content{
        display: inline-block;
      }
    }
  }
}
</style>